/* eslint-disable jsx-a11y/anchor-is-valid */
import { renderRichTextByKey, getShortTextByKey } from '$cms/getDataByKey';
import { useAppContext } from '$util/AppContext';
import type { CmsContentDictionary, CmsContentProps } from '$cms/index';
import { ContentComponentSection } from '$src-components/atoms/ContentComponentSection';
import { Col, Grid, Row } from '$src-components/atoms/Grid';

const getCmsData = (cmsData: CmsContentDictionary) => {
  const getRichText = renderRichTextByKey.bind(cmsData);
  const getShortText = getShortTextByKey.bind(cmsData);

  return {
    settingsButtonText: getShortText('page.cookie-policy.settings-button-text', 'choices'),
    settings: getShortText(
      'page.cookie-policy.settings',
      'Protecting your online data is a priority for Fixter. You can reconsider your choices regarding cookies at any time by using our cookie-management tool:'
    ),
    body: getRichText(
      'page.cookie-policy.body',
      <>
        <h1>Cookie Policy for Fixter</h1>

        <p>This is the Cookie Policy for Fixter, accessible from www.fixter.co.uk</p>

        <h2>What Are Cookies</h2>

        <p>
          As is common practice with almost all professional websites this site uses cookies, which are tiny
          files that are downloaded to your computer, to improve your experience. This page describes what
          information they gather, how we use it and why we sometimes need to store these cookies. We will
          share how you can prevent these cookies from being stored however this may downgrade or break
          certain elements of the sites functionality.
        </p>

        <p>For more general information on cookies see the Wikipedia article on HTTP Cookies.</p>

        <h2>How We Use Cookies</h2>

        <p>
          We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no
          industry standard options for disabling cookies without completely disabling the functionality and
          features they add to this site. It is recommended that you leave on all cookies if you are not sure
          whether you need them or not in case they are used to provide a service that you use.
        </p>

        <h2>Disabling Cookies</h2>

        <p>
          You can prevent the setting of cookies by adjusting the settings on your browser (see your browser
          Help for how to do this). Be aware that disabling cookies will affect the functionality of this and
          many other websites that you visit. Disabling cookies will usually result in also disabling certain
          functionality and features of the this site. Therefore it is recommended that you do not disable
          cookies.
        </p>

        <p>
          You can learn how to manage cookies on your web browser by following the{' '}
          <a href="https://privacypolicies.com/blog/browser-cookies-guide/">Browser Cookies Guide</a>.
        </p>

        <h2>The Cookies We Set</h2>

        <ul>
          <li>
            <p>Account related cookies</p>
            <p>
              If you create an account with us then we will use cookies for the management of the signup
              process and general administration. These cookies will usually be deleted when you log out
              however in some cases they may remain afterwards to remember your site preferences when logged
              out.
            </p>
          </li>

          <li>
            <p>Login related cookies</p>
            <p>
              We use cookies when you are logged in so that we can remember this fact. This prevents you from
              having to log in every single time you visit a new page. These cookies are typically removed or
              cleared when you log out to ensure that you can only access restricted features and areas when
              logged in.
            </p>
          </li>

          <li>
            <p>Orders processing related cookies</p>
            <p>
              This site offers e-commerce or payment facilities and some cookies are essential to ensure that
              your order is remembered between pages so that we can process it properly.
            </p>
          </li>

          <li>
            <p>Forms related cookies</p>
            <p>
              When you submit data to through a form such as those found on contact pages or comment forms
              cookies may be set to remember your user details for future correspondence.
            </p>
          </li>

          <li>
            <p>Site preferences cookies</p>
            <p>
              In order to provide you with a great experience on this site we provide the functionality to set
              your preferences for how this site runs when you use it. In order to remember your preferences
              we need to set cookies so that this information can be called whenever you interact with a page
              is affected by your preferences.
            </p>
          </li>
        </ul>

        <h2>Third Party Cookies</h2>

        <p>
          In some special cases we also use cookies provided by trusted third parties. The following section
          details which third party cookies you might encounter through this site.
        </p>

        <ul>
          <li>
            <p>
              This site uses Google Analytics which is one of the most widespread and trusted analytics
              solution on the web for helping us to understand how you use the site and ways that we can
              improve your experience. These cookies may track things such as how long you spend on the site
              and the pages that you visit so we can continue to produce engaging content.
            </p>
            <p>For more information on Google Analytics cookies, see the official Google Analytics page.</p>
          </li>

          <li>
            <p>
              Third party analytics are used to track and measure usage of this site so that we can continue
              to produce engaging content. These cookies may track things such as how long you spend on the
              site or pages you visit which helps us to understand how we can improve the site for you.
            </p>
          </li>

          <li>
            <p>
              From time to time we test new features and make subtle changes to the way that the site is
              delivered. When we are still testing new features these cookies may be used to ensure that you
              receive a consistent experience whilst on the site whilst ensuring we understand which
              optimisations our users appreciate the most.
            </p>
          </li>

          <li>
            <p>
              As we sell products it is important for us to understand statistics about how many of the
              visitors to our site actually make a purchase and as such this is the kind of data that these
              cookies will track. This is important to you as it means that we can accurately make business
              predictions that allow us to monitor our advertising and product costs to ensure the best
              possible price.
            </p>
          </li>
        </ul>

        <h2>More Information</h2>

        <p>
          Hopefully that has clarified things for you and as was previously mentioned if there is something
          that you are not sure whether you need or not it is usually safer to leave cookies enabled in case
          it does interact with one of the features you use on our site. This Cookies Policy was created with
          the help of the Generator of <a href="https://cookiepolicygenerator.com">GDPR Cookies Policy</a>.
        </p>

        <p>
          However if you are still looking for more information then you can contact us through one of our
          preferred contact methods:
        </p>

        <ul>
          <li>Email: support@fixter.co.uk</li>
        </ul>

        <h2>Annex 1: LIST OF COOKIES COLLECTED</h2>

        <ul>
          <li>
            <h4>Fixter essential cookies</h4>
            <p>
              These cookies are strictly necessary to provide you with services available through our Websites
              and to use some of its features, such as access to secure areas.
            </p>
            <ul>
              <li>
                <strong>fixterPartner</strong> - Keeps track of the partner that referred you to us. This
                helps us customise your experience and apply the right discounts.
                <br />
                <em>Expires: 1 day.</em>
              </li>
              <li>
                <strong>partnerCustomerId</strong> - Keeps track of the partner reference number. This helps
                us and the partner that referred you to us, to offer you the right experience.
                <br />
                <em>Expires: 1 day.</em>
              </li>
              <li>
                <strong>fixterMarketingCampaign</strong> - Keeps track of the marketing campaign you reached
                us with. This helps us customise your experience and apply the right discounts.
                <br />
                <em>Expires: 7 days.</em>
              </li>
              <li>
                <strong>fixterAccessToken</strong> - Keeps track of your authentication to continue through
                your booking.
                <br />
                <em>Expires: 30 days.</em>
              </li>
            </ul>
          </li>

          <li>
            <h4>Fixter performance and functionality cookies</h4>
            <p>
              These cookies are used to enhance the performance and functionality of our Websites but are
              non-essential to their use. However, without these cookies, certain functionality may become
              unavailable.
            </p>
            <ul>
              <li>
                <strong>fixterHome</strong> - Keeps track of the first page you used when you arrived on our
                website. This is used to provide you with a consistent website navigation.
                <br />
                <em>Expires: 7 days</em>
              </li>
              <li>
                <strong>fixterLanding</strong> - Keeps track of the first page you used when you arrived on
                our website. This is used to provide you with a consistent website navigation.
                <br />
                <em>Expires: 7 days</em>
              </li>
              <li>
                <strong>fixterSegment</strong> - Keeps track of which version of Fixter you are using. This is
                used to show you the relevant currency symbols and translated texts.
                <br />
                <em>Expires: None. Session cookie</em>
              </li>
              <li>
                <strong>fixterVrm</strong> - Keeps track of the last vehicle VRM you searched on our website.
                This is used to pre-fill some forms on the website.
                <br />
                <em>Expires: None. Session cookie</em>
              </li>
              <li>
                <strong>fixterPostcode</strong> - Keeps track of the last postcode you searched on our
                website. This is used to pre-fill some forms on the website.
                <br />
                <em>Expires: None. Session cookie</em>
              </li>
              <li>
                <strong>
                  fixterSessionId, acquisitionMethod, EnableMotServiceBundle, fixterAdminLogin,
                  kameleoonVisitorCode, landing-postcode-collection-type, loginEmail, trackBooking,
                  fixterEmailCampaign
                </strong>{' '}
                - These cookies are used to customise the checkout flow.
                <br />
                <em>
                  Expires: The longest lasting cookie expires 30 days after your last visit to the website or
                  when you close your browser.
                </em>
              </li>
            </ul>
          </li>

          <li>
            <h4>Google analytics cookies</h4>
            These cookies collect information that is used in aggregate form to help us understand how our
            Websites are being used or how effective are marketing campaigns are.
            <ul>
              <li>
                <strong>_ga, _gat, _gid, _gaexp, _gat_UA-99816388-1</strong>
                <br />
                <em>
                  The longest lasting cookie expires 2 years, 1 day after your last visit to the website or
                  when you close your browser.
                </em>
              </li>
            </ul>
          </li>

          <li>
            <h4>Microsoft bing analytics cookies</h4>
            These cookies collect information that is used in aggregate form to help us understand how our
            Websites are being used or how effective are marketing campaigns are.
            <ul>
              <li>
                <strong>_uetsid</strong>
                <br />
                <em>Expires: None. Session cookie</em>
              </li>
            </ul>
          </li>

          <li>
            <h4>Stripe cookies</h4>
            These cookies are used by <a href="https://www.stripe.com">stripe.com</a> to secure your payment
            experience. For more details see{' '}
            <a href="https://www.stripe.com/cookies-policy/legal">their cookie policy</a>
            <ul>
              <li>
                <strong>__stripe_sid, __stripe_mid, __stripe-js-v3-features__</strong>
                <br />
                <em>Expires: None, session cookie</em>
              </li>
            </ul>
          </li>

          <li>
            <h4>Mixpanel cookies</h4>
            These cookies are used by <a href="https://mixpanel.com">mixpanel.com</a> to collect analytics
            data and hep us understand how our websites are being used. For more details see{' '}
            <a href="https://mixpanel.com/legal/privacy-policy/">their privacy policy</a>
            <ul>
              <li>
                <strong>
                  mp_7918a81543378f1cffc6346ddc9390cf_mixpanel, mp_ef3601f74d65343cc6495d1b5b1174aa_mixpanel,
                  mp_d5c244ca73269736d4b502ec35b4475c_mixpanel, mp_7918a81543378f1cffc6346ddc9390cf_mixpanel
                </strong>
                <br />
                <em>Expires: 2 years after your last visit</em>
              </li>
            </ul>
          </li>

          <li>
            <h4>Hotjar cookies</h4>
            These cookies are used by <a href="https://www.hotjar.com">hotjar.com</a> to collect standard
            internet log information and details of visitor behaviour patterns. We do this to find out things
            such as the number of visitors to the various parts of the site. We collect this information in a
            way which does not personally identify anyone. For more details see{' '}
            <a href="https://www.hotjar.com/legal/policies/cookie-information">
              their cookie information page
            </a>
            <ul>
              <li>
                <strong>
                  _hjClosedSurveyInvites, _hjDonePolls, _hjMinimizedPolls, _hjDoneTestersWidgets,
                  _hjMinimizedTestersWidgets, _hjIncludedInSample
                </strong>
                <br />
                <em>Expires: 365 days</em>
              </li>
            </ul>
          </li>

          <li>
            <h4>Adalyser cookies</h4>
            <a href="https://adalyser.com">Adalyser.com</a> uses these cookies to collect standard internet
            log information and details of visitor behaviour patterns connected with television
            advertisements. We do this to determine the number of visitors to our site as a result of
            television advertisements. We collect this information in a way which does not personally identify
            anyone. For more details see{' '}
            <a href="https://adalyser.com/en/cookies">their cookie information page</a>
            <ul>
              <li>
                <strong>_adal_ca, _adal_cw, _adal_id, _adal_ses</strong>
                <br />
                <em>Expires: 365 days</em>
              </li>
            </ul>
          </li>
        </ul>
      </>
    ),
  };
};

export default function CookiePolicy() {
  const AppContext = useAppContext<CmsContentProps>();
  const {
    cmsContent: { dictionary },
  } = AppContext;

  const { body, settings, settingsButtonText } = getCmsData(dictionary);

  return (
    <Grid>
      <Row>
        <Col>
          <ContentComponentSection>
            <p>
              {settings}{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (window.OneTrust) window.OneTrust.ToggleInfoDisplay();
                }}
                role="button"
              >
                {settingsButtonText}
              </a>
            </p>
            {body}
          </ContentComponentSection>
        </Col>
      </Row>
    </Grid>
  );
}
